// Core
import React from 'react';

// Libraries
import { useTranslation } from 'react-i18next';

// Types
import { MeasurementType } from '../../../../../../types/global';

// Components
import {
  LineChart,
  LineChartType,
} from '../../../../../../layout/elements/LineChart';

// View
import { HydraulicUnitProps } from './HydraulicUnit.types';
import { ChartMode } from '../Trendings.types';

function HydraulicUnit({
  className,
  testId,
  trendingHydraulicUnitData,
  chartMode,
}: HydraulicUnitProps): JSX.Element {
  // Dependencies
  const { t } = useTranslation();

  // Generate dynamic ID based on chart mode
  const chartId: string = `hydraulic-unit-${chartMode}`;

  return (
    <LineChart
      className={className}
      data={trendingHydraulicUnitData}
      id={chartId}
      activeBullet={chartMode === ChartMode.live || chartMode === ChartMode.liveAggregate}
      series={[
        {
          name: t('common.cloudConnection'),
          field: 'edgeStatus',
          type: LineChartType.fill,
          date: 'timestamp',
          opposite: true,
        },
        {
          name: t('view.crusher.hydraulic.trampPressure'),
          field: 'hydraulicTrampPressure',
          type: LineChartType.line,
          date: 'timestamp',
          color: 'green',
          unit: 'PSI',
          bullet: true,
          measurementType: MeasurementType.pressure,
          minScale: 0,
          maxScale: 25,
        },
        {
          name: t('view.crusher.hydraulic.clampPressure'),
          field: 'hydraulicClampPressure',
          type: LineChartType.line,
          measurementType: MeasurementType.pressure,
          date: 'timestamp',
          color: 'blue',
          unit: 'PSI',
          bullet: true,
          minScale: 0,
          maxScale: 25,
        },
      ]}
      testId={testId}
    />
  );
}

export { HydraulicUnit };
